	<template>
		<label class="switch"><input type="checkbox" value="on"><div class="slider"></div></label>
	</template>
	<script>
		export default{
			name:'paco-switch'
		}
	</script>


// WEBPACK FOOTER //
// Switch.vue?156f78ca